import { useMutation } from 'query';
import { reportContentObject } from '../../services';

export const useReportContentObjectMutation = () =>
  useMutation<unknown, { id: string }>({
    async mutationFn({ id }) {
      /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
      await reportContentObject({ body: { abuse_report: { content_object_id: id } } });
      /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
    },
  });
